/** @format */

import React from 'react';
import update from 'immutability-helper';
import SuperAgent from 'superagent';
import {CONTACT_TYPE_FEEDBACK} from 'frontier-constants';

export default ComponentContainer => {
    return class extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                sending: false,
                sent: false,
                isSubmissionSuccessful: false,
                closeModalUponSuccess: false,
                formData: {
                    email: '',
                    comment: ''
                }
            };
        }

        handleChange = updateTarget => {
            this.setState(update(this.state, updateTarget));
        };

        handleSend = () => {
            this.setState({sending: true}, () => {
                SuperAgent.post('/legacy/contacts/send')
                    .set('accept', 'application/json')
                    .send({
                        comment: 'From CEO Form: ' + this.state.formData.comment,
                        email: this.state.formData.email,
                        type_id: CONTACT_TYPE_FEEDBACK
                    })
                    .end((err, response) => {
                        this.setState({sent: true, sending: false});
                        if (err || !response.body) {
                            this.setState({
                                error: response.body ? response.body : err
                            });
                        } else {
                            this.setState({
                                isSubmissionSuccessful: true
                            });
                            setTimeout(() => {
                                this.setState({closeModalUponSuccess: true});
                            }, 3000);
                        }
                    });
            });
        };

        render() {
            const props = {...this.props};

            props.onChange = this.handleChange;
            props.onSend = this.handleSend;

            return <ComponentContainer {...props} {...this.state} />;
        }
    };
};
